import { createFileRoute } from '@tanstack/react-router'

import {
  getCurriculumDetailsQueryOptions,
  CurriculumManagementEditView
} from '@/modules/curriculumsManagement'

export const Route = createFileRoute('/_auth/curricula/$curriculumId/edit')({
  component: CurriculumManagementEditView,
  loader: async ({ context, params }) =>
    context.queryClient.ensureQueryData(
      getCurriculumDetailsQueryOptions(params.curriculumId)
    )
})
